import {NewDynamicTab } from "../../../components/Page";
import { HpgclTitle } from "../components";
import { TabSwitcher } from "../Hppc_Das";
import OverviewChart from "./OverviewChart";
import { HpgcOverviewDefaultDates } from "../../../config/DefaultDates";
const HaryanaOverview = () => {
  return (
    <NewDynamicTab
      defaultDates={HpgcOverviewDefaultDates}
      headerPrefixComponent={<TabSwitcher />}
      header="Overview "
      middleComponent={<HpgclTitle/>}
      showTabs={false}
      tabs={{ 
        "Overview": <OverviewChart />,

       }}
    />
  );
};

export default HaryanaOverview;
